import { TableColumn } from '../shared/table/table.component';

export const columnsPerson: TableColumn[] = [
  {
    field: 'fullname',
    caption: 'IND.NAME_LASTNAME',
    type: 'link',
    linkToRedirectTo: '/individuals/profile/',
    fieldOfRedirection: 'id',
  },
  {
    field: 'authorities',
    caption: 'IND.AUTHORITY',
    type: 'regular',
  },
  {
    field: 'stock',
    caption: 'IND.STOCK',
    type: 'regular',
  },
  {
    field: 'powers',
    caption: 'IND.POWER',
    type: 'regular',
  },
  {
    field: 'old_powers',
    caption: 'INDV.POA_NO_VIGENTES',
    type: 'regular',
  },
  {
    field: 'action',
    caption: 'LABELS.ACTIONS',
    type: 'icon-multi-action',
    multiActionIcons: [
      {
        actionTitle: 'LABELS.EDIT',
        icon: 'edit',
        link: '/individuals/profile/',
        fieldOfRedirection: 'id',
        conditional: false,
      },
      {
        actionType: 'download',
        actionTitle: 'BUTTONS.DOWNLOAD',
        icon: 'file_download',
      },
      {
        actionType: 'delete',
        conditional: true,
        fieldOfCondition: 'enableDelete',
        actionTitle: 'LABELS.DELETE',
        icon: 'delete_outline',
      },
    ],
  },
];
export const columnLegalPerson: TableColumn[] = [
  {
    field: 'name',
    caption: 'LABELS.NAME',
    type: 'link',
    linkToRedirectTo: '/individuals/profile/',
    fieldOfRedirection: 'id',
  },
  {
    field: 'authorities',
    caption: 'IND.AUTHORITY',
    type: 'regular',
  },
  {
    field: 'stock',
    caption: 'IND.STOCK',
    type: 'regular',
  },
  {
    field: 'powers',
    caption: 'IND.POWER',
    type: 'regular',
  },
  {
    field: 'action',
    caption: 'LABELS.ACTIONS',
    type: 'icon-multi-action',
    multiActionIcons: [
      {
        actionTitle: 'LABELS.EDIT',
        icon: 'edit',
        link: '/individuals/profile/',
        fieldOfRedirection: 'id',
        conditional: false,
      },
      {
        actionType: 'download',
        actionTitle: 'BUTTONS.DOWNLOAD',
        icon: 'file_download',
      },
      {
        actionType: 'delete',
        conditional: true,
        fieldOfCondition: 'enableDelete',
        actionTitle: 'LABELS.DELETE',
        icon: 'delete_outline',
      },
    ],
  },
];
export const powerIndvTable: TableColumn[] = [
  {
    field: "name",
    caption: "LABELS.POA_NAME",
    type: "text-action",
    actionType: "navigate",
  },
  {
    field: "grant_date",
    caption: "LABELS.GRANT_DATE",
    type: "date-badge",
  },
  {
    field: "individuals",
    caption: "LABELS.PROXIES_NAME",
    type: "detailed",
  },
  {
    field: "facultaties",
    caption: "LABELS.POWERS_CONFERRED",
    type: "detailed",
  },
  {
    field: "power_type",
    caption: "LABELS.TYPE_POWER",
    type: "badge",
    colorField: "power_type",
    translate: true,
    badgeVariants: {
      'POWER_TYPES.GENERAL': 'primary',
      'POWER_TYPES.SPECIAL': 'neutral',
    },
    emptyLabel: 'LABELS.NO_TYPE',
  },
  {
    field: 'power_status',
    caption: 'LABELS.STATUS',
    type: 'badge',
    colorField: 'power_status_id',
    translate: true,
    badgeVariants: {
      1: 'neutral',
      2: 'success',
      3: 'warning',
      4: 'warning',
      5: 'danger',
      6: 'neutral',
      7: 'danger',
    },
    emptyLabel: 'LABELS.NO_STATUS',
  },
  {
    field: "has_files",
    type: "icon-multi-action",
    caption: " ",
    multiActionIcons: [
      {
        actionType: "navigate",
        icon: "visibility",
        actionTitle: "INDV.VIEW_POWER",
      }
    ],
  },
];
export const shareholderIndvTable: TableColumn[] = [
  {
    field: "fullname",
    caption: "LABELS.SHAREHOLDER",
    type: "link",
    linkToRedirectTo: "/individuals/profile/",
    fieldOfRedirection: "individual_id",
  },
  {
    field: "percentage",
    caption: "LABELS.OWNERSHIP_PERCENTAJE",
    type: "percentage",
  },
  {
    field: "actions_cuotes",
    caption: "LABELS.AMOUNT_SHARES",
    type: "regular",
  },
  {
    field: "shares_class_name",
    caption: "LABELS.SHARES_CLASSES",
    type: "badge",
    badgeVariants: {},
  },
  {
    field: "shares_type_name",
    caption: "LABELS.SHARES_TYPES",
    type: "badge",
    badgeVariants: {},
  },
  {
    field: "vote_value",
    caption: "LABELS.VOTE_VALUE",
    type: "badge",
    badgeVariants: {},
  },
  {
    field: "has_files",
    type: "icon-multi-action",
    caption: " ",
    multiActionIcons: [
      {
        actionType: "navigate",
        icon: "visibility",
        actionTitle: "INDV.VIEW_SHARES",
      }
    ],
  },
];
export const authIndvTable: TableColumn[] = [
  {
    field: "fullname",
    caption: "LABELS.NAME",
    type: "link",
    linkToRedirectTo: "/individuals/profile/",
    fieldOfRedirection: "individual_id",
  },
  {
    field: "position",
    caption: "LABELS.POSITION",
    type: "regular",
  },
  {
    field: "designation_date",
    caption: "LABELS.DESIGNATION_DATE",
    type: "date-badge",
  },
  {
    field: "expiration_date",
    caption: "LABELS.TERM_EXPIRATION",
    type: "date-badge",
  },
  {
    field: "free_text",
    caption: "LABELS.OBSERVATIONS",
    type: "regular",
  },
  {
    field: "has_files",
    type: "icon-multi-action",
    caption: " ",
    multiActionIcons: [
      {
        actionType: "navigate",
        icon: "visibility",
        actionTitle: "INDV.VIEW_AUTHORITY",
      }
    ],
  },
];

export const IndividualsES = {
  DATA: 'Datos de la persona ',
  ADDRESS: 'Direccion',
  DOC: 'Documentos',
  ATTACH_DOCS: 'Documentos Vinculados',
  POWER: 'Apoderado',
  SHAREHOLDER: 'Accionista',
  AUTH: 'Autoridad',
  LEGAL: 'Representante legal',
  VIEW_POWER: 'Ver poder',
  VIEW_SHARES: 'Ver Acciones',
  VIEW_AUTHORITY: 'Ver Autoridades',
  POWERS: 'Poderes',
  NO_LINKS: 'No hay vinculaciones',
  VIGENTES: 'Vigentes',
  NO_VIGENTES: 'No vigentes',
  POA_NO_VIGENTES: 'Poderes no vigentes',
};

export const IndividualsEN = {
  DATA: 'Person data',
  ADDRESS: 'Address',
  DOC: 'Documents',
  ATTACH_DOCS: 'Linked documents',
  POWER: 'Proxie',
  SHAREHOLDER: 'Shareholder',
  AUTH: 'Authority',
  LEGAL: 'Legal representative',
  VIEW_POWER: 'View POA',
  VIEW_SHARES: 'View shares',
  VIEW_AUTHORITY: 'View authorities',
  POWERS: 'POA',
  NO_LINKS: 'There are no linkages',
  VIGENTES: 'Current',
  NO_VIGENTES: 'No current',
  POA_NO_VIGENTES: 'No active POAs',
};

export const TabsLinkages = [
  { id: 'powers_companies', label: 'INDV.POWER', links: [] },
  { id: 'shaerholder_linkages', label: 'INDV.SHAREHOLDER', links: [] },
  { id: 'auth_linkages', label: 'INDV.AUTH', links: [] }
];